export default "__VITE_ASSET__BCi0v7XT__"